<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          v-model="selectedClinic"
          :rules="clinicRules"
          label="clinic*"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="selectedOfficialName" label="officialname" />
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="selectedName" label="name" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-combobox
          clearable
          :items="salesDrops"
          v-model="selectedSalesDrop"
          label="salesdrop"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          type="number"
          v-model="selectedSalesthreshold"
          label="salesthreshold"
        />
      </v-col>
      <v-col cols="4">
        <v-select
          clearable
          v-model="selectedCutoff"
          :items="cutOffs"
          label="cutoff"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field
          :type="'number'"
          v-model="selectedCutoffmonths"
          label="cutoffmonths"
        />
      </v-col>
      <v-col cols="4">
        <v-select
          clearable
          v-model="selectedNeversold"
          :items="neverSolds"
          label="neversold"
        />
      </v-col>
      <v-col cols="4">
        <v-select
          clearable
          v-model="selectedPass"
          :items="passes"
          label="pass"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-combobox
          clearable
          v-model="selectedGroupName"
          :items="groupNames"
          label="Groupname"
        />
      </v-col>
      <v-col cols="4">
        <v-select
          clearable
          :items="labIdModes"
          v-model="selectedLabIdMode"
          label="Lab ID Mode"
        />
      </v-col>
      <v-col cols="4">
        <v-select
          clearable
          :items="rxIds"
          v-model="selectedRxId"
          label="rxid"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-combobox
          clearable
          :items="inHouseFilters"
          v-model="selectedInHouseFilter"
          label="inhousefilter"
        />
      </v-col>
      <v-col cols="4">
        <v-combobox
          clearable
          :items="inHouseSrcs"
          v-model="selectedInHouseSrc"
          label="inhousesrc"
        />
      </v-col>
      <v-col cols="4">
        <v-select
          clearable
          :items="vendorFilters"
          v-model="selectedVendorFilter"
          label="vendorfilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-select
          clearable
          multiple
          :items="localeOptions"
          v-model="selectedLocaleOptions"
          label="locale"
        />
      </v-col>
    </v-row>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>More Advanced flags</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="4">
              <v-combobox
                clearable
                :items="categoryClassifications"
                v-model="selectedCategoryClassification"
                label="categoryclassification"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                type="number"
                v-model="selectedCutoffthreshold"
                label="cutoffthreshold"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                clearable
                :items="outputModes"
                v-model="selectedOutputMode"
                label="outputmode"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-combobox
                clearable
                :items="updatedSrcFiles"
                v-model="selectedUpdatedSrcFile"
                label="updatedsrcfile"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                clearable
                v-model="selectedPreserveVariationNames"
                :items="offOnOptions"
                label="preservevariationnames"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                clearable
                :items="offOnOptions"
                v-model="selectedPreservePrices"
                label="preserveprices"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-select
                clearable
                :items="offOnOptions"
                v-model="selectedOmitSizeProperty"
                label="omitsizeproperty"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                clearable
                :items="dontClearQOHOptions"
                v-model="selectedDontClearQOH"
                label="dontclearqoh"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                clearable
                :items="offOnOptions"
                v-model="selectedIgnorePimsLabInfo"
                label="ignorepimslabinfo"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-select
                clearable
                :items="mergeDispensingFeedOptions"
                v-model="selectedMergeDispensingFees"
                label="mergedispensingfees"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                :items="clearMinimumPriceOptions"
                v-model="selectedClearMinimumPrice"
                label="clearminimumprice"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                type="number"
                v-model="minimumDiagnosisMatch"
                label="mindiagmatch"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                type="number"
                v-model="diagnosisIgnoreCount"
                label="diagnosisignorecount"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-switch
                v-model="useProvidedVariationName"
                label="useprovidedvariationname"
              />
            </v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="ml-4"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>Should only be used with the pricelistmatcher mode</span>
            </v-tooltip>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                :disabled="isReMatch"
                v-model="selectedFullCore"
                label="fullcore"
              />
            </v-col>
            <v-col class="d-flex align-end" cols="9">
              <v-combobox
                counter
                clearable
                deletable-chips
                small-chips
                multiple
                hide-selected
                type="number"
                v-model="selectedReMatch"
                label="rematch"
              />
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ml-2 mb-6"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>
                  Type numbers of orig order values that you want to process.
                  Matcher will only process those lines.
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { DEFAULTS } from '@/constants';
import _ from 'lodash';

const { CUSTOM_PARAMETERS } = DEFAULTS.MATCHER;
const DEFAULT_LOCALE = [
  _.get(_.head(CUSTOM_PARAMETERS.LOCALE_OPTIONS), 'value')
];

export default {
  props: {
    business: {
      type: Object,
      default: () => ({})
    },
    context: {
      type: String,
      default: () => undefined
    },
    isReMatch: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    'business.name': function (newVal) {
      this.selectedOfficialName = newVal;
      this.selectedClinic = _.snakeCase(newVal);
    },
    context: {
      deep: true,
      handler(newVal) {
        if (newVal && typeof newVal === 'string')
          this.setCurrentContext(this.parseContext(this.context));
        else this.setDefaultContext();
      }
    }
  },
  created() {
    if (this.context) this.setCurrentContext(this.parseContext(this.context));
    else this.setDefaultContext();

    if (this.business && this.business.name) {
      const businessName =
        this.business && this.business.name ? this.business.name : '';
      this.selectedOfficialName = businessName;
      this.selectedClinic = _.snakeCase(businessName);
    }
  },
  data() {
    return {
      outputModes: CUSTOM_PARAMETERS.OUTPUT_MODE,
      salesDrops: CUSTOM_PARAMETERS.SALES_DROP,
      groupNames: CUSTOM_PARAMETERS.GROUPNAMES,
      labIdModes: CUSTOM_PARAMETERS.LAB_ID_MODES,
      rxIds: CUSTOM_PARAMETERS.RX_IDS,
      inHouseFilters: CUSTOM_PARAMETERS.IN_HOUSE_FILTERS,
      inHouseSrcs: CUSTOM_PARAMETERS.IN_HOUSE_SRCS,
      vendorFilters: CUSTOM_PARAMETERS.VENDOR_FILTERS,
      categoryClassifications: CUSTOM_PARAMETERS.CATEGORY_CLASSIFICATIONS,
      cutOffs: CUSTOM_PARAMETERS.CUT_OFFS,
      neverSolds: CUSTOM_PARAMETERS.NEVER_SOLDS,
      passes: CUSTOM_PARAMETERS.PASSES,
      updatedSrcFiles: CUSTOM_PARAMETERS.UPDATED_SRC_FILES,
      offOnOptions: CUSTOM_PARAMETERS.OFF_ON_OPTIONS,
      mergeDispensingFeedOptions:
        CUSTOM_PARAMETERS.MERGE_DISPENSING_FEED_OPTIONS,
      clearMinimumPriceOptions: CUSTOM_PARAMETERS.CLEAR_MINIMUM_PRICE_OPTIONS,
      dontClearQOHOptions: CUSTOM_PARAMETERS.DONT_CLEAR_QOH_OPTIONS,
      localeOptions: CUSTOM_PARAMETERS.LOCALE_OPTIONS,

      clinicRules: [
        (v) => !!v || 'Clinic is required',
        (v) =>
          (v && v.length <= 120) || 'Clinic must be less than 120 characters'
      ],
      salesthresholdRules: [
        (v) => !!v || 'Clinic is required',
        (v) =>
          (v && v.length <= 120) || 'Clinic must be less than 120 characters'
      ],
      //output
      selectedOfficialName: '',
      selectedClinic: '',
      selectedSalesDrop: 'year',
      selectedSalesthreshold: 10,
      selectedCutoffthreshold: 3,
      selectedCutoff: _.head(CUSTOM_PARAMETERS.CUT_OFFS),
      selectedCutoffmonths: 36,
      selectedNeversold: _.head(CUSTOM_PARAMETERS.NEVER_SOLDS),
      selectedPass: _.head(CUSTOM_PARAMETERS.PASSES),
      selectedGroupName: '',
      selectedLabIdMode: _.head(CUSTOM_PARAMETERS.LAB_ID_MODES),
      selectedRxId: null,
      selectedName: '',
      selectedInHouseFilter: null,
      selectedInHouseSrc: null,
      selectedVendorFilter: null,
      selectedCategoryClassification: null,
      selectedOutputMode: _.head(CUSTOM_PARAMETERS.OUTPUT_MODE),
      selectedUpdatedSrcFile: null,
      selectedPreserveVariationNames: _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS),
      selectedPreservePrices: _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS),
      selectedOmitSizeProperty: _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS),
      selectedReMatch: [],
      selectedFullCore: true,
      selectedMergeDispensingFees: _.head(
        CUSTOM_PARAMETERS.MERGE_DISPENSING_FEED_OPTIONS
      ),
      selectedClearMinimumPrice: _.head(
        CUSTOM_PARAMETERS.CLEAR_MINIMUM_PRICE_OPTIONS
      ),
      selectedDontClearQOH: _.head(CUSTOM_PARAMETERS.DONT_CLEAR_QOH_OPTIONS),
      selectedIgnorePimsLabInfo: null,
      selectedLocaleOptions: DEFAULT_LOCALE,
      minimumDiagnosisMatch: 0.6,
      diagnosisIgnoreCount: 5,
      useProvidedVariationName: false
    };
  },
  methods: {
    setCurrentContext(context) {
      this.selectedOfficialName = context.officialname;
      this.selectedClinic = context.clinic;
      this.selectedSalesDrop = context.salesdrop;
      this.selectedSalesthreshold = context.salesthreshold;
      this.selectedCutoff = context.cutoff;
      this.selectedCutoffmonths = context.cutoffmonths;
      this.selectedNeversold = context.neversold;
      this.selectedPass = context.pass;
      this.selectedGroupName = context.groupname;
      this.selectedLabIdMode = context.labidmode;
      this.selectedRxId = context.rxid;
      this.selectedName = context.name;
      this.selectedInHouseFilter = context.inhousefilter;
      this.selectedInHouseSrc = context.inhousesrc;
      this.selectedVendorFilter = context.vendorfilter;
      this.selectedCategoryClassification = context.categoryclassification;
      this.selectedCutoffthreshold = context.cutoffthreshold;
      this.selectedOutputMode = context.outputmode;
      this.selectedUpdatedSrcFile = context.updatedsrcfile;
      this.selectedPreserveVariationNames = context.preservevariationnames;
      this.selectedPreservePrices = context.preserveprices;
      this.selectedOmitSizeProperty = context.omitsizeproperty;
      this.selectedReMatch = context.rematch;
      this.selectedFullCore = context.fullcore ?? true;
      this.selectedMergeDispensingFees = context.mergedispensingfees;
      this.selectedClearMinimumPrice = context.clearminimumprice;
      this.selectedDontClearQOH = context.dontclearqoh;
      this.selectedIgnorePimsLabInfo = context.ignorepimslabinfo;
      this.selectedLocaleOptions = context.locale || DEFAULT_LOCALE;
      this.minimumDiagnosisMatch = context.mindiagmatch;
      this.diagnosisIgnoreCount = context.diagnosisignorecount;
      this.useProvidedVariationName = context.useprovidedvariationname;
    },
    setDefaultContext() {
      this.selectedOfficialName = '';
      this.selectedClinic = '';
      this.selectedSalesDrop = 'year';
      this.selectedSalesthreshold = 10;
      this.selectedCutoff = 'firm';
      this.selectedCutoffmonths = 36;
      this.selectedNeversold = _.head(CUSTOM_PARAMETERS.NEVER_SOLDS);
      this.selectedPass = _.head(CUSTOM_PARAMETERS.PASSES);
      this.selectedGroupName = '';
      this.selectedLabIdMode = _.head(CUSTOM_PARAMETERS.LAB_ID_MODES);
      this.selectedRxId = null;
      this.selectedName = '';
      this.selectedInHouseFilter = null;
      this.selectedInHouseSrc = null;
      this.selectedVendorFilter = null;
      this.selectedCategoryClassification = null;
      this.selectedCutoffthreshold = 3;
      this.selectedOutputMode = _.head(CUSTOM_PARAMETERS.OUTPUT_MODE);
      this.selectedUpdatedSrcFile = null;
      this.selectedPreserveVariationNames = _.head(
        CUSTOM_PARAMETERS.OFF_ON_OPTIONS
      );
      this.selectedPreservePrices = _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS);
      this.selectedOmitSizeProperty = _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS);
      this.selectedReMatch = [];
      this.selectedFullCore = true;
      this.selectedMergeDispensingFees = _.head(
        CUSTOM_PARAMETERS.MERGE_DISPENSING_FEED_OPTIONS
      );
      this.selectedClearMinimumPrice = _.head(
        CUSTOM_PARAMETERS.CLEAR_MINIMUM_PRICE_OPTIONS
      );
      this.selectedDontClearQOH = _.head(
        CUSTOM_PARAMETERS.DONT_CLEAR_QOH_OPTIONS
      );
      this.selectedIgnorePimsLabInfo = null;
      this.selectedLocaleOptions = DEFAULT_LOCALE;
      this.minimumDiagnosisMatch = 0.6;
      this.diagnosisIgnoreCount = 5;
      this.useProvidedVariationName = false;
    },
    parseContext(contextString) {
      let outputContext;
      try {
        outputContext = JSON.parse(contextString);
      } catch (error) {
        outputContext = {};
      }
      return outputContext;
    },
    getData() {
      const reMatchItems =
        this.selectedReMatch?.map((orderNumber) => parseInt(orderNumber, 10)) ||
        [];

      return {
        clinic: this.selectedClinic,
        officialname: this.selectedOfficialName,
        name: this.selectedName,
        salesdrop: this.selectedSalesDrop,
        salesthreshold: this.selectedSalesthreshold,
        cutoff: this.selectedCutoff,
        cutoffmonths: this.selectedCutoffmonths,
        pass: this.selectedPass,
        neversold: this.selectedNeversold,
        ...(this.selectedGroupName
          ? { groupname: this.selectedGroupName }
          : {}),
        labidmode: this.selectedLabIdMode,
        rxid: this.selectedRxId,
        inhousefilter: this.selectedInHouseFilter,
        inhousesrc: this.selectedInHouseSrc,
        vendorfilter: this.selectedVendorFilter,
        categoryclassification: this.selectedCategoryClassification,
        cutoffthreshold: this.selectedCutoffthreshold,
        outputmode: this.selectedOutputMode,
        updatedsrcfile: this.selectedUpdatedSrcFile,
        preservevariationnames: this.selectedPreserveVariationNames,
        preserveprices: this.selectedPreservePrices,
        omitsizeproperty: this.selectedOmitSizeProperty,
        fullcore: this.selectedFullCore,
        mergedispensingfees: this.selectedMergeDispensingFees,
        clearminimumprice: this.selectedClearMinimumPrice,
        dontclearqoh: this.selectedDontClearQOH,
        ignorepimslabinfo: this.selectedIgnorePimsLabInfo,
        locale: this.selectedLocaleOptions,
        mindiagmatch: Number(this.minimumDiagnosisMatch),
        diagnosisignorecount: Number(this.diagnosisIgnoreCount),
        useprovidedvariationname: this.useProvidedVariationName,
        ...(reMatchItems.length ? { rematch: reMatchItems } : {})
      };
    }
  }
};
</script>
